const PAGE_FEATURES = {
  REPLY: 'has_reply',
  STORE: 'has_store',
  BOT: 'has_bot',
  POSTER: 'has_poster',
  REFERRAL: 'referral',
}

export default PAGE_FEATURES
